import React, { useContext } from 'react'
import IntervenersList from './IntervenersList'
import IntervenerCards from './IntervenerCards'
import GlobalContext from '../GlobalContext'

export default function ActiveIntervenersTab ({ interveners, deleteIntervener }) {
  const { screens } = useContext(GlobalContext)

  return (
    <>
      { !screens.xs && <IntervenersList interveners={interveners} deleteIntervener={deleteIntervener} /> }
      { screens.xs && <IntervenerCards interveners={interveners} /> }
    </>
  )
}
